import Image from 'next/image'
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'
import Link from 'next/link'
interface SecBookConsultationProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	image?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
	button?: {
		label?: string
		href?: string
	}
	options_page: string[]
}

export const fields = [
	// heading
	'heading.title',

	// text
	'text.text',

	// image
	'image.alt',
	'image.image_file.image.id',
	'image.image_file.image.filename_download',

	// button
	'button.label',
	'button.href',

	// options_page
	'options_page',
] as const

export default function SecBookConsultation({ data }: { data: SecBookConsultationProps }) {
	const image_height_full = data?.options_page?.includes('image_height_full')
	return (
		<section className='SecBookConsultation relative bg-[#f7f7f7]'>
			<div className='container'>
				<div className='flex flex-wrap flex-row-reverse'>
					{/* Image Section - Full width to screen edge */}
					<div className='w-full lg:w-1/2'>
						<div className={`relative lg:absolute w-full aspect-square lg:top-0 lg:right-0 ${image_height_full ? 'lg:w-1/2 lg:h-full' : 'lg:w-[calc(50%-3rem)] lg:h-[calc(100%+4rem)]'} max-sm:h-[350px] max-sm:w-screen max-sm:-ml-6`}>
							{data?.image?.image_file?.image?.id && (
								<Image
									src={getReadableImageUrl(
										data.image.image_file.image.id,
										data.image.image_file.image.filename_download || ''
									)}
									alt={data.image?.alt || ''}
									fill
									className='object-cover md:rounded-bl-[66px]'
									priority
								/>
							)}
						</div>
					</div>

					{/* Content Section */}
					<div className='w-full lg:w-1/2 py-8 md:py-16'>
						{/* Benefits Section */}
						<div className='grid gap-6'>
							<h2>{data?.heading?.title || ''}</h2>
							{data?.text?.text && (
								<div
									className='grid gap-6'
									dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
								/>
							)}

							{data?.button?.label && (
								<Link
									href={data.button?.href || '/'}
									className='btn'
									onClick={e => {
										if (data.button?.href) {
											e.preventDefault()
											window.location.href = data.button.href
										}
									}}
								>{data.button.label}
								</Link>
							)}
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
